import React from 'react';
import {
  Button, Typography, TextField, InputAdornment, Icon, Dialog, DialogContent, IconButton,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Password from '../../assets/img/password.svg';
import { forgotPasswordDialogs } from '../../css/style';
import { isWidthDown } from '@material-ui/core/withWidth';

const styles = forgotPasswordDialogs();


const ResetPasswordDialog = (props) => {
  const {
    dialogState, onClose, onClickNext, onTextFieldChange, errorText, width,
  } = props;
  const isMobile = !!width && isWidthDown('xs', width);
  return (
    <Dialog
      maxWidth="xl"
      open={dialogState}
      onClose={() => onClose()}
    >
      <DialogContent style={!isMobile ? styles.dialogContainer : styles.dialogContainerMobile}>
        <IconButton
          style={styles.closeButtonStyle}
          onClick={() => onClose()}
        >
          <Icon>close</Icon>
        </IconButton>
        <img src={Password} alt="password" style={styles.topImage} />
        <Typography style={styles.dialogTitle}>PASSWORD RESET</Typography>
        <Typography style={styles.dialogDescription}>
          Enter your email address below and we’ll send you a verification code to reset your password.
        </Typography>
        <TextField
          style={{ ...styles.inputTextField, width: '85%' }}
          placeholder="EMAIL"
          onChange={event => onTextFieldChange(event)}
          variant="outlined"
        />
        <Button
          style={styles.bottomButton}
          onClick={() => onClickNext()}
        >
          RESET PASSWORD
        </Button>
        <Typography style={styles.errorTextStyle}>{errorText}</Typography>
      </DialogContent>
    </Dialog>
  );
};

ResetPasswordDialog.propTypes = {
  dialogState: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickNext: PropTypes.func.isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
};

export default ResetPasswordDialog;
